export const defaultValues = {
  name: '',
  email: '',
  phoneCode: '+52',
  phone: '',
};
